import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ allowedRoles, children }) {
  const { userRole, isLoading } = useAuth();
  const location = useLocation();

  // Show nothing while checking auth status to prevent redirect flicker
  if (isLoading) {
    return null;
  }

  if (!userRole) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(userRole)) {
    const dashboardMap = {
      student: '/dashboard/student',
      teacher: '/dashboard/teacher',
      admin: '/dashboard/admin',
    };
    return <Navigate to={dashboardMap[userRole] || '/'} replace />;
  }

  return children;
}
